import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["value"]

import { computed, inject } from 'vue';
    import type { AuthState } from '../composables/useAuth';
    import { AUTH_STATE_KEY } from '../composables/authKeys';
    import PasswordAuthSection from './PasswordAuthSection.vue';
    import OAuthAuthSection from './OAuthAuthSection.vue';

    interface ServerTypeOption {
        value: string;
        label: string;
    }

    interface Props {
        direction: 'source' | 'dest';
        title: string;
        headerClass: string;
        serverTypeOptions: ServerTypeOption[];
        migrationType: 'Mail' | 'Contacts';
        useOAuthPredicate: (serverType: string) => boolean;
        onAuthError: (title: string, message: string) => void;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ServerCredentialCard',
  props: {
    direction: {},
    title: {},
    headerClass: {},
    serverTypeOptions: {},
    migrationType: {},
    useOAuthPredicate: { type: Function },
    onAuthError: { type: Function }
  },
  setup(__props: any) {

    const props = __props;

    const authState = inject(AUTH_STATE_KEY) as AuthState;

    const serverTypeRef = computed(() => 
        props.direction === 'source' ? authState.sourceServerType : authState.destServerType
    );

    const shouldUseOAuth = computed(() => 
        props.useOAuthPredicate(serverTypeRef.value.value)
    );

    const directionCapitalized = computed(() => 
        props.direction === 'source' ? 'Source' : 'Destination'
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card-header text-white", __props.headerClass])
    }, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(__props.title), 1 /* TEXT */)
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", {
          for: `${__props.direction}ServerType`,
          class: "form-label"
        }, "Server Type", 8 /* PROPS */, _hoisted_5),
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          id: `${__props.direction}ServerType`,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serverTypeRef.value.value) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.serverTypeOptions, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option.value,
              value: option.value
            }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_7))
          }), 128 /* KEYED_FRAGMENT */))
        ], 8 /* PROPS */, _hoisted_6), [
          [_vModelSelect, serverTypeRef.value.value]
        ])
      ]),
      (!shouldUseOAuth.value)
        ? (_openBlock(), _createBlock(PasswordAuthSection, {
            key: 0,
            direction: __props.direction,
            migrationType: __props.migrationType
          }, null, 8 /* PROPS */, ["direction", "migrationType"]))
        : (_openBlock(), _createBlock(OAuthAuthSection, {
            key: 1,
            direction: directionCapitalized.value,
            serverType: serverTypeRef.value.value,
            migrationType: __props.migrationType,
            onAuthError: __props.onAuthError
          }, null, 8 /* PROPS */, ["direction", "serverType", "migrationType", "onAuthError"]))
    ])
  ]))
}
}

})